import { HttpErrorResponse } from "@angular/common/http";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { Upload } from "app/core/models/upload.model";
import { FileUploadComponent } from "app/shared/components/file-upload/file-upload.component";
import { ImportNavComponent } from "app/shared/components/import-nav/import-nav.component";
import { isEmpty } from "lodash-es";
import { EncounterTypeEligibilityImportsService } from '../../../core/services/encounter-type-eligibility-imports.service';

@Component({
    selector: 'app-capture-admin-import-encounter-type-eligibilities',
    templateUrl: './capture-admin-import-encounter-type-eligibilities.component.html',
    styleUrls: ['./capture-admin-import-encounter-type-eligibilities.component.scss'],
    imports: [
        ImportNavComponent,
        FileUploadComponent,
        FaIconComponent
    ]
})
export class CaptureAdminImportEncounterTypeEligibilitiesComponent {

  private encounterTypeEligibilityImportsService = inject(EncounterTypeEligibilityImportsService);
  private router = inject(Router);

  uploading = false;
  formModel = {};
  errors: string[] = [];

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.encounterTypeEligibilityImportsService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/import-encounter-type-eligibilities/history']);
        this.uploading = false;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError() {
    this.uploading = false;
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}